/* eslint-disable no-mixed-spaces-and-tabs */

import io from "socket.io-client";

export default function() {
  const socket = io.connect(process.env.baseURL, { forceNew: true });

  socket.on("error", err => {
    console.log("Socket_error_:", err);
  });

  function receiveACK() {
    socket.on("receiveACK", data => {
      console.log("receiveACK:", data);
    });
  }

  function notification(message) {
    socket.emit("notification", message);
  }

  function receive(dispatch, type) {
    socket.on("receive", data => {
      dispatch({ type: type, Obj: data });
    });
  }

  return {
    receiveACK,
    receive,
    notification
  };
}



// WEBPACK FOOTER //
// ./src/assets/Socket.js